export default {"src":"/_next/static/media/happyInactive_24.478572b8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};